/* eslint-disable no-restricted-globals */
import React, { useState, useEffect, useRef, useMemo } from "react";
import styled, { css } from "styled-components";
import { useNavigate } from "react-router-dom";

import { theme } from "styles";
import Text from "components/ui/Text";
import TextField from "components/ui/TextField";
import Button from "components/entrance/Button";
import LeftArrow from "assets/icons/left-arrow.svg";

const PasswordTemplate = ({
  title,
  inputValue,
  inputValueChange,
  buttonOnClick,
  onClickBack,
}) => {
  const navigate = useNavigate();
  const pageRef = useRef();
  const [height, setHeight] = useState(window.innerHeight);
  const [step, setStep] = useState(1);
  const [inputValidation, setInputValidation] = useState([
    {
      step: 2,
      text: "8자 이상 숫자와 영어를 포함해서 입력해주세요",
      color: "gray20",
    },
    {
      step: 1,
      text: "8자 이상 숫자와 영어를 포함해서 입력해주세요",
      color: "gray20",
    },
  ]);
  const [focused, setFocused] = useState(inputValue.map((v) => false));
  const onFocus = (i) => {
    setFocused((previousValue) =>
      previousValue.map((v, idx) => (i === idx ? true : false))
    );
  };
  const onBlur = (i) => {
    setTimeout(() => {
      setFocused((previousValue) =>
        previousValue.map((v, idx) => (i === idx ? false : v))
      );
    }, 100);
  };

  useEffect(() => {
    return () => {
      setFocused([false, false]);
    };
  }, []);

  useEffect(() => {
    window.visualViewport.addEventListener("resize", (e) => {
      const pageHeight = e.target.height;
      setHeight(pageHeight + scrollY);
    });
    return;
  }, []);

  const handleClickBack = () => {
    if (onClickBack) {
      onClickBack();
      return;
    }
    navigate(-1);
  };

  const handleClickFooter = (i) => {
    if (i === 0) {
      setStep(2);
    }
    if (i === 1) {
      buttonOnClick();
    }
  };

  const checkPwValidation = useMemo(() => {
    const [passwordConfirm, password] = inputValue;
    let pwVal = false;
    let pwConfirmVal = false;
    if (password.length < 8) {
      pwVal = false;
      return [pwVal, pwConfirmVal];
    }
    if (password.length > 7) {
      if (password.match(/[a-zA-Z]/g) && password.match(/[0-9]/g)) {
        setInputValidation((previousValue) =>
          previousValue.map((value, idx) =>
            idx === 1
              ? { ...value, text: "안전한 비밀번호입니다", color: "primary50" }
              : value
          )
        );
        pwVal = true;
      } else {
        setInputValidation((previousValue) =>
          previousValue.map((value, idx) =>
            idx === 1
              ? {
                  ...value,
                  text: "8자 이상 숫자와 영어를 포함해서 입력해주세요",
                  color: "danger",
                }
              : value
          )
        );
        pwVal = false;
        return [pwVal, pwConfirmVal];
      }
    }

    if (passwordConfirm.length > 7) {
      if (password !== passwordConfirm) {
        setInputValidation((previousValue) =>
          previousValue.map((value, idx) =>
            idx === 0
              ? {
                  ...value,
                  text: "비밀번호가 동일하지 않아요",
                  color: "danger",
                }
              : value
          )
        );
        pwConfirmVal = false;
        return [pwVal, pwConfirmVal];
      } else {
        setInputValidation((previousValue) =>
          previousValue.map((value, idx) =>
            idx === 0
              ? { ...value, text: "안전한 비밀번호입니다", color: "primary50" }
              : value
          )
        );
        pwConfirmVal = true;
      }
    }
    return [pwVal, pwConfirmVal];
  }, [inputValue]);

  return (
    <Wrapper ref={pageRef} height={height}>
      <WrapperTop>
        <WrapperHeader>
          <div onClick={handleClickBack}>
            <img src={LeftArrow} alt="back" />
          </div>
        </WrapperHeader>
        <Text fontSize="24px" fontWeight="700" lineHeight="30px">
          {title}
        </Text>
        <WrapperInput>
          <TextField
            pattern={false}
            type="passwordWithEye"
            maxLength="100"
            label="비밀번호 확인"
            value={inputValue[0]}
            onChange={inputValueChange[0]}
            autoFocus={step === 2}
            focused={focused[0]}
            onFocus={() => onFocus(0)}
            onBlur={() => onBlur(0)}
            validation={inputValidation[0]}
            css={css`
              transition: all 1.5s;
              opacity: ${step === 2 ? 1 : 0};
            `}
          />
          <TextField
            pattern={false}
            type="passwordWithEye"
            maxLength="100"
            label="비밀번호"
            value={inputValue[1]}
            onChange={inputValueChange[1]}
            autoFocus={step === 1}
            focused={focused[1]}
            onFocus={() => onFocus(1)}
            onBlur={() => onBlur(1)}
            validation={inputValidation[1]}
            css={css`
              -webkit-transition: all 0.5s ease;
              -moz-transition: all 0.5s ease;
              -ms-transition: all 0.5s ease;
              -o-transition: all 0.5s ease;
              transition: all 0.5s ease;

              -webkit-transform: scale(1);
              -moz-transform: scale(1);
              -ms-transform: scale(1);
              -o-transform: scale(1);
              transform: scale(1);

              margin-top: -100px;
              transform: ${step === 1 ? "translateY(0)" : "translateY(110px)"};
            `}
          />
        </WrapperInput>
      </WrapperTop>

      <WrapperBtm>
        {focused.filter((v) => v).length === 0 && step === 1 && (
          <Button
            color={checkPwValidation[0] ? "white" : "disable"}
            background={checkPwValidation[0] ? "primary100" : "gray5"}
            onClick={checkPwValidation[0] ? () => setStep(2) : () => {}}
          >
            다음
          </Button>
        )}
        {focused.filter((v) => v).length === 0 && step === 2 && (
          <Button
            color={checkPwValidation[1] ? "white" : "disable"}
            background={checkPwValidation[1] ? "primary100" : "gray5"}
            onClick={checkPwValidation[1] ? buttonOnClick : () => {}}
          >
            확인
          </Button>
        )}
        {focused[1] && (
          <Footerbox
            onClick={
              checkPwValidation[0] ? () => handleClickFooter(0) : () => {}
            }
            background={checkPwValidation[0] ? "primary100" : "gray5"}
          >
            <Text
              color={checkPwValidation[0] ? "white" : "disable"}
              fontSize="18px"
              lineHeight="24px"
            >
              {step === 1 ? "다음" : "확인"}
            </Text>
          </Footerbox>
        )}
        {focused[0] && (
          <Footerbox
            onClick={
              checkPwValidation[1] ? () => handleClickFooter(1) : () => {}
            }
            background={checkPwValidation[1] ? "primary100" : "gray5"}
          >
            <Text
              color={checkPwValidation[1] ? "white" : "disable"}
              fontSize="18px"
              lineHeight="24px"
            >
              확인
            </Text>
          </Footerbox>
        )}
      </WrapperBtm>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 0 20px 42px;
  background: #fff;
  height: ${(props) => `${props.height}px`};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
`;
const Footerbox = styled.div`
  position: absolute;
  bottom: 0;
  width: 100vw;
  height: 56px;
  margin-left: -20px;
  padding: 16px 24px;
  text-align: center;
  background: ${(props) => `${theme.colors[props.background]}`};
  z-index: 10;
`;

const WrapperTop = styled.div`
  white-space: pre;
`;

const WrapperHeader = styled.div`
  height: 52px;
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  div {
    padding: 4px 20px 4px 0;
  }
`;
const WrapperInput = styled.div`
  margin-top: 32px;
`;

const WrapperBtm = styled.div`
  button {
    margin-top: 24px;
  }
`;

export default PasswordTemplate;
